import Icon from '../components/Icon.vue'

Icon.register({"taxi":{"width":512,"height":512,"paths":[{"d":"M462 243.9L440.1 156.6A79.9-79.9 0 0 1 362.5 96H352V56C352 42.7 341.3 32 328 32H184C170.7 32 160 42.7 160 56V96H149.5A79.9-79.9 0 0 1 71.9 156.6L50 243.9C25.5 252.8 8 276.4 8 304V352C8 372.2 17.4 390.2 32 401.9V456C32 469.3 42.7 480 56 480H104C117.3 480 128 469.3 128 456V416H384V456C384 469.3 394.7 480 408 480H456C469.3 480 480 469.3 480 456V401.9C494.6 390.2 504 372.2 504 352V304C504 276.4 486.5 252.8 462 243.9zM149.5 160H362.5A16-16 0 0 0 378 172.1L395 240H117L134 172.1A16-16 0 0 0 149.5 160zM132 336C132 355.9 115.9 372 96 372S60 355.9 60 336 76.1 300 96 300 132 316.1 132 336zM452 336C452 355.9 435.9 372 416 372S380 355.9 380 336 396.1 300 416 300 452 316.1 452 336z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/taxi.js
// module id = B4D6
// module chunks = 0